import { render, staticRenderFns } from "./CajaDiariaShow.vue?vue&type=template&id=24aef894"
import script from "./CajaDiariaShow.vue?vue&type=script&lang=ts"
export * from "./CajaDiariaShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports